import SecurityIcon from '@mui/icons-material/Security';
import { Box, Typography } from '@mui/material';

const NothingSelected = () => (
  <Box
    sx={{
      height: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      p: 4,
    }}
  >
    <SecurityIcon sx={{ fontSize: 48, opacity: 0.25 }} />
    <Typography variant="h6" color="text.secondary">
      No user selected
    </Typography>
    <Typography variant="body2" color="text.secondary" textAlign="center">
      Pick a user on the left to review the roles they hold and the permissions granted to them directly.
    </Typography>
  </Box>
);

export default NothingSelected;
